import { NgModule } from '@angular/core';
import { ProgramRoutingModule } from './program-routing.module';
import { HubHomeModule } from './hub-home/hub-home.module';
import { SimulationEditModule } from './simulation-edit/simulation-edit.module';
import { ProgramListModule } from './program-list/program-list.module';
import { ProgramHomeModule } from './program-home/program-home.module';
import { ProgramTemplatePickerModule } from './program-template-picker/program-template-picker.module';

@NgModule({
  declarations: [
  ],
  imports: [
    ProgramRoutingModule,
    HubHomeModule,
    SimulationEditModule,
    ProgramListModule,
    ProgramHomeModule,
    ProgramTemplatePickerModule
  ]
})
export class ProgramModule { }
